import React from 'react';
import styles from './Cart.scss';
import PropTypes from 'prop-types';
import CartEmptyStateSvg from './CartEmptyStateSvg';
import { Text } from 'wix-style-react';

export default function CartEmptyState({ t }) {
  return (
    <div className={styles.wrapper} data-hook="cart-empty-state-wrapper">
      <div className={styles.emptyState}>
        <div className={styles.emptyStateInner}>
          <CartEmptyStateSvg className={styles.emptyStateIllustration} />
          <Text
            size="small"
            weight="normal"
            light
            secondary
            className={styles.emptyStateInnerText}
            data-hook="cart-empty-state-text"
          >
            {t('phoneordering_menu_ordercolumn_emptystate')}
          </Text>
        </div>
      </div>
    </div>
  );
}

CartEmptyState.propTypes = {
  t: PropTypes.func,
};

CartEmptyState.displayName = 'CartEmptyState';
